module.exports = __webpack_public_path__ + "img/homeCompanyProfileData.939ef26e.png";